export default __webpack_public_path__ + "static/media/logo-thin.ebeb6a26.png";